import styled from 'styled-components'
import { device } from '@/common/constants/device'
import Text from '@/components/common/Text'
import Row from '@/components/common/Row'
import ButtonIcon from '@/components/common/ButtonIcon'

const Container = styled(Row)`
  margin-bottom: 1rem;
  width: 100%;
  border-radius: 3px;
  background-color: var(--yellow);
  padding: 12px;
  justify-content: center;
  border-radius: 32px;
  position: relative;
`
const Button = styled.button`
  margin-left: 1.5rem;
  font-size: 1em;
  font-weight: 800;
  border-radius: 12px;
  padding: 12px;
  background-color: var(--black-russian);
  color: white;
  transition: color 0.26s ease-in-out, background-color 0.26s ease-in-out;

  &:hover {
    background-color: var(--natural-black);
    color: var(--supernova);
  }

  @media ${device.laptop} {
    margin-left: 12px;
  }
`

const ButtonClose = styled(ButtonIcon)`
  width: 24px;
  height: 24px;
  cursor: pointer;
  background-color: black;
  transition: transform 0.26s ease-in-out;
  flex-shrink: 0;
  position: absolute;
  right: 40px;
`

const Alert = ({ text, btnText, handleClick, children, onClose }) => {
  const onCloseClick = () => {
    onClose()
  }
  return (
    <Container alignItems="center">
      {text && (
        <Text color={'black'} size={'16'} weight={'600'}>
          {text}
        </Text>
      )}
      {children}
      {btnText && (
        <Button filled onClick={handleClick}>
          {btnText}
        </Button>
      )}
      {onClose && (
        <ButtonClose
          className="button-close"
          type="button"
          icon="creatives-close"
          onClick={onCloseClick}
        />
      )}
    </Container>
  )
}

export default Alert
